export default (value: string = '') => {
  const strippedValue = value.replace(/\s+/g, '');
  const hasLength = strippedValue.length > 0;

  return !hasLength;
};
